export const DROPDOWN_HEIGHT = 256;

export const SIZE_CONFIG: Record<
  "small" | "medium" | "large",
  { trigger: string; text: string }
> = {
  small: {
    trigger: "min-h-8 md:min-h-7 px-2 py-0.5",
    text: "text-base md:text-xs",
  },
  medium: { trigger: "min-h-8 px-2.5 py-1", text: "text-base md:text-sm" },
  large: { trigger: "min-h-10 px-2.5 py-1.5", text: "text-base md:text-sm" },
};
